export default "__VITE_ASSET__DsL9$x3O__"